






































import SensitivityLabel from "@/components/SensitivityLabel.vue";
import Vue from "vue";
export default Vue.extend({
  props: ["sensitivities", "toggle_sensitivity"],
  components: { SensitivityLabel },
});
